/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const appCardHoldersDetailConfig = {
  appCardList: [
    {
      id: '1',
      appCardImage:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.images/fhp-favicon.png',
      appCardTitle: 'Flexible Hurricane Protection',
      appCardDescription: 'Year 2023-24',
      appCardList: [
        {
          value: 'B2CGS50000123',
        },
      ],
    },
  ],
  activePage: 1,
  pageSize: 10,
  totalCount: 1,
  totalPages: 1,
  icon: 'https://i.ibb.co/N1bKMG1/saral-jeevan-logo.png',
};
